export default function stripHtml(str: string) {
  const regex = /(<([^>]+)>)/gi
  return str.replace(regex, "")
}
